import { Outlet, Route, Routes } from 'react-router-dom';
import './App.css';
import Landing from './pages/Landing';
import 'sweetalert2/src/sweetalert2.scss'
import './assets/scss/main.scss';
import './assets/scss/owl.carousel.min.scss';
import './assets/scss/owl.theme.default.min.scss';
import './assets/scss/style.scss';
import './assets/scss/ticketing.scss';
import 'bootstrap/scss/bootstrap.scss';
import 'leaflet/dist/leaflet.css';
import routes from './routes';
import Footer from './components/Footer';
import { useContext, useEffect, useMemo, useState } from 'react';
import '../node_modules/react-toastify/scss/main.scss';
import { ToastContainer } from 'react-toastify';
import { Elements } from '@stripe/react-stripe-js';
import { loadStripe } from '@stripe/stripe-js';
import NavBar from './layouts/NavBar';
import GlobalContext from './context/store';
import getCompany from './services/company';
import { Get } from './api/server';
import { BookingContextProvider } from './context/booking';
import Booking from './components/Booking';
import { AffContext } from './context/AffiliateContext';
import useAffiliate from './hooks/useAffiliate';
import Analytics from './analytics/Analytics';

function Layout() {
  const { showBooking, setShowBooking } = useContext(GlobalContext);

  return (
    <>
      <div id="page-wrapper">
        <Analytics />
        <NavBar />
        <Outlet />
        <ToastContainer
          position="top-right"
          autoClose={5000}
          hideProgressBar={false}
          newestOnTop
          closeOnClick
          rtl={false}
          pauseOnFocusLoss
          draggable
          pauseOnHover
          theme="light"
          toastClassName="myToast"
        />
        <div style={{ marginTop: 10 }}>
          <Footer />
        </div>
      </div>
      <Booking show={showBooking} onHide={() => setShowBooking(false)} />
    </>
  );
}

function App() {
  const [company, setcompany] = useState({});
  const [services, setservices] = useState([]);
  const [showBooking, setShowBooking] = useState(false);
  const [aff, setAff] = useAffiliate();
  const [affId, setAffId] = useState(null);
  // eslint-disable-next-line no-unused-vars
  // stripe keys: pk_test_Oe4N8QyHsRI4av8sgZcGe6R2, pk_live_eHPsjUYyy6mpbgQRFUWoy44x
  const [stripePromise, setStripePromise] = useState(() => loadStripe('pk_live_eHPsjUYyy6mpbgQRFUWoy44x', {
    stripeAccount: 'acct_1Qe7BdC10d37n3S8'
  }))


    // const [stripePromise, setStripePromise] = useState(() => loadStripe('pk_test_ERNCnPwW7Sbm9E4BUbPZdZqO', {
    //   stripeAccount: 'acct_1JpRgvQdHkUVZxl4'
    // }))
  
  const store = useMemo(
    () => ({ company, setcompany, services, setservices, showBooking, setShowBooking }),
    [company, services, showBooking],
  );
  const affiliateStore = useMemo(
    () => ({ aff, setAff, affId, setAffId }),
    [aff, affId, setAff],
  );

  useEffect(() => {
    async function getInitData() {
      const myCompany = await getCompany();
      const services = await Get(`/bookingservices/getCompaniesServices/${myCompany._id}`);
      setcompany(myCompany);
      setservices(services.filter(service => service.active === true));
    }
    getInitData();
  }, []);

  return (
    <GlobalContext.Provider value={store}>
      <AffContext.Provider value={affiliateStore}>
        <BookingContextProvider>
          <Elements stripe={stripePromise}>
            <Routes>
              <Route path="/" element={<Layout />}>
                {routes.map((route, key) => (
                  <Route
                    key={key}
                    path={route.path}
                    element={route.Element}
                    exact={route.exact}
                  />
                ))}
                <Route path="*" element={<Landing />} />
              </Route>
            </Routes>
          </Elements>
        </BookingContextProvider>
      </AffContext.Provider>
    </GlobalContext.Provider>
  );

  
}



export default App;
